<div class="grid m-0 p-0">
  <div class="col-12">
    <p-inputNumber
      class="p-inputtext-sm"
      type="number"
      [(ngModel)]="this.radius"
    />
    <button
      pButton
      class="virtualcenter-button virtualcenter-button--primary"
      [label]="'Recalcular'"
      (click)="this.recalculate()"
    ></button>
  </div>
  <div class="col-12">
    <div
      #map
      style="height: 800px"
      leaflet
      [leafletOptions]="options"
      [leafletLayers]="this.markers"
      (leafletMapReady)="onMapReady($event)"
    ></div>
  </div>
</div>
